import { Component } from '@angular/core';

@Component({
	selector: 'app-map-legend',
	templateUrl: './map-legend.component.html',
	styleUrls: ['./map-legend.component.scss']
})
export class MapLegendComponent {
	legendOpened: boolean = false;


	showHideLegend = (show: boolean) => {
		this.legendOpened = show;
	}
}
